import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  if (!token) {
    return (
      <div className="login-page">
        <div className="login-card">
          <header className="login-header">
            <div className="brand-mark">
              <img src="/icons/markaii-m.png?v=2" alt="" className="brand-mark-icon" />
              <span>Markaii</span>
            </div>
            <h1>Invalid link</h1>
            <p className="login-sub">This reset link is missing or malformed.</p>
          </header>
          <div className="login-form">
            <Link to="/forgot-password" className="btn btn-primary" style={{ display: 'block', textAlign: 'center' }}>
              Request a new link
            </Link>
          </div>
        </div>
      </div>
    );
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(null);
    if (newPassword.length < 10) {
      setError('Password must be at least 10 characters.');
      return;
    }
    if (newPassword !== confirm) {
      setError("Passwords don't match.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: newPassword }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        const messages = {
          invalid_or_expired_token: 'This link has expired or already been used. Request a new one.',
          password_too_short: 'Password must be at least 10 characters.',
        };
        throw new Error(messages[data.error] || 'Something went wrong. Try again.');
      }
      navigate('/login?reset=1', { replace: true });
    } catch (err) {
      setError(err.message || 'Something went wrong. Try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <header className="login-header">
          <div className="brand-mark">
            <img src="/icons/markaii-m.png?v=2" alt="" className="brand-mark-icon" />
            <span>Markaii</span>
          </div>
          <h1>Choose a new password</h1>
          <p className="login-sub">At least 10 characters.</p>
        </header>

        <form onSubmit={handleSubmit} className="login-form" autoComplete="off">
          <label className="login-field">
            <span>New password</span>
            <input
              type="password"
              name="new-password"
              autoComplete="new-password"
              required
              minLength={10}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="••••••••••"
              disabled={loading}
              autoFocus
            />
          </label>

          <label className="login-field">
            <span>Confirm password</span>
            <input
              type="password"
              name="confirm-password"
              autoComplete="new-password"
              required
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="••••••••••"
              disabled={loading}
            />
          </label>

          {error && <div className="login-error">{error}</div>}

          <button type="submit" className="btn btn-primary" disabled={loading}>
            {loading ? 'Saving…' : 'Set new password'}
          </button>

          <p className="login-footnote">
            <Link to="/forgot-password">Request a new link</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
